/* global customElements, Service */



import {LitElement, html} from 'lit';

import {property, customElement} from 'lit/decorators.js';

import {Service} from '../service/service.js';
import {SessionStorageUtil} from '../utils/browserStorageSanitizer.js';



class MainHeader extends LitElement {



	static get properties() {

		return {

			pageTitle: {type: String},

			companyName: {type: String}

		};

	}



	constructor() {

		super();

		this.pageTitle = 'Dashboard';

		this.companyName = '';

		this.newMenuState = false;

		

		this.updateCompany();

	}

	

	render() {	

		return html`

			<style>

				.app-header-bar {

					border-bottom: 1px solid darkgray;

					background-color: ${this.getBackgroundColor()};

					color: ${this.getTextColor()};

					padding: 5px;

					border-bottom: 2px solid ${this.getAccentColor()};

					box-shadow: 3px 3px 15px grey;

				}



				.header-row {

					display: flex;

					align-items: center;

					width: 100%;

					gap: 8px;

				}



				.header-left {

					flex: 0 0 auto;

					display: flex;

					align-items: center;

					gap: 8px;

				}



				.header-center {

					flex: 1 1 auto;

					min-width: 0;

					text-align: center;

					font-weight: 300;

				}



				.header-right {

					flex: 0 0 auto;

					display: flex;

					align-items: center;

					gap: 4px;

					max-width: 45%;

				}



				.header-user-menu {

					flex: 0 1 auto;

					min-width: 0;

					max-width: 160px;

				}



				.unread {

					margin-right: 15px;

					text-align: center;

					width: 25px;

					color: #fff300;

				}



				.no-messages {

					margin-right: 15px;

					width: 25px;

				}

				

				.page-header-text {

					font-size: 18px;

				}

				

				.page-title {

					overflow: hidden;

					text-overflow: ellipsis;

					white-space: nowrap;

				}

				

				.company-name {

					font-size: 14px;

					white-space: nowrap;

					overflow: hidden;

					text-overflow: ellipsis;

					color: ${this.getCompanyText()};

				}

				

				@media only screen and (max-width: 600px) {

					.logo {

						display: none;

					}

		

					.page-header-text {

						font-size: 16px;

					}



					.company-name {

						display: none;

					}



					.header-user-menu {

						max-width: 110px;

					}

				}

				

			</style>

			<div class="app-header-bar">

				<div class="header-row">

					<div class="header-left">

						<vaadin-icon icon="vaadin:menu" style="cursor: pointer; border: 1px solid lightgrey; padding: 5px; border-radius: 3px;" title="Toggle Menu" @click="${this.toggleMenu}"></vaadin-icon>

						<slot class="logo" name="logo"></slot>

					</div>

					<div class="header-center page-header-text">

						<span class="company-name">

							${this.companyName}

						</span>

						<div class="page-title">${this.pageTitle}</div>

					</div>

					<div class="header-right">

						<dl-notification-watcher></dl-notification-watcher>

						<div class="header-user-menu">

							<dl-user-menu></dl-user-menu>

						</div>

					</div>

				</div>

			</div>		  

		`;

	}

	

	updateCompany() {

		var header = this;

		

		Service.getCompanyService().getCurrentCompany().then(function(companyAll) {

			var workingCompanyId = SessionStorageUtil.getItem('workingCompany');

			var workingWith = '';

			if (workingCompanyId) {

				workingWith = 'Working with: ';

			}			

			

			var references = '';

			var referencesInside = [];

			if (companyAll.company.referenceCode) {

				referencesInside.push('Reference: ' + companyAll.company.referenceCode);				

			}

			if (companyAll.company.carrierId) {

				referencesInside.push('Carrier Id: ' + companyAll.company.carrierId);				

			}			

			

			if (referencesInside.length > 0) {

				references =  ' (' + referencesInside.join(' ') + ')';

			}

			

			var timezone = 'CST6CDT';

			if (companyAll.company.baseTimeZone) {

				timezone = companyAll.company.baseTimeZone;

				SessionStorageUtil.setItem('companyTimeZone', companyAll.company.baseTimeZone);

			} else {

				SessionStorageUtil.setItem('companyTimeZone', companyAll.company.serverTimeZone);

			}

			

			header.companyName = workingWith + companyAll.company.companyName + references + ' Company Timezone: ' + timezone;			

		});	

	}

	

	toggleMenu() {

		var header = this;

		header.newMenuState = !header.newMenuState;

		

		var itemSelectEvent = new CustomEvent('toggle-menu', { detail: { hide: header.newMenuState} });

		header.dispatchEvent(itemSelectEvent);

	}

	

	getCompanyText() {

		return window.DL.Branding.companyTextColor;

	}

	

	getBackgroundColor() {

		return window.DL.Branding.headerBackgroundColor;	

	}

	

	getTextColor() {

		return window.DL.Branding.headerTextColor;

	}

	

	getAccentColor() {

		return window.DL.Branding.navBackgroundColor;	

	}

	

};



customElements.define('dl-main-header', MainHeader);


